import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width:70
    },
    {
        title:Util.L('SKU'),
        key:'sku'
    },
    {
        title:Util.L('ProductName'),
        key:'productName'
    },
    {
        title: Util.L('OrderQty'),
        width:100,
        slot: 'orderQty'
    },
    {
        title: Util.L('Action'),
        width:100,
        fixed:'right',
        slot: 'action',
        align: 'center'
    }
]